/**
 * Created by Marcus Zhao on 11/28/2020
 * Description:
 *
 * ---------maintenance history-------------
 */
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ContactTemplateType, ControlId, RelationshipAction, ContactTemplateOpenOptions, JobTitleAction } from '../../../contact-dialog-new/contact-dialog.model';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ValidRelationshipType } from '@tamalelibs/models/valid-relationship-type.model';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { ChangeContactTemplateValueSet, REMOVE_JOB_TITLE, ADD_JOB_TITLE } from '@tamalelibs/redux/contact.actions';
import { EntityService } from '@tamalelibs/services/entity.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { of as observableOf } from 'rxjs';
import { OpenDynamicComponentService } from '../../../../pages/home/home-open-dynamic-component';
import { NewRelationshipService } from '../../../new-relationship-dialog/new-relationship-dialog.service';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { EntryService } from '@tamalelibs/services/entry.service';
import { EntityBack, EntityDialogOpenOptions, EntityDialogType } from '../../../entity-dialog/entity-dialog.model';
import { Relationship } from '@tamalelibs/models/relationship.model';
import { validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import { debounceTime, filter, take } from 'rxjs/operators';
import * as _lodash from 'lodash';
import { contactNewAddedJobTitleSelector } from '@tamalelibs/redux/contact.reducer';
import { Contact } from '@tamalelibs/models/contact.model';
import { RelationshipDialogOpenOptions } from '../../../new-relationship-dialog/new-relationship-dialog.model';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { EntityBrief } from '@tamalelibs/models/entity-brief.model';
import { BriefObject } from '@tamalelibs/models/brief-object';
import { OnDestroy } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { businessConstants } from '../../../../constants/business.constants';

@Component({
    selector: 'tam-contact-med',
    templateUrl: './contact-med.component.html',
    styleUrls: ['./contact-med.component.scss'],
    standalone: false
})
export class ContactMedComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;

    @Input() valueChangeSubject: ReplaySubject<ContactTemplateControlValue>;
    @ViewChild('entitylist', { static: false }) entitylist;
    isFly = true;
    readOnly = false; // flag to disable auto complete

    inputValue = ''; // input box text value

    dataItems: Array<any> = []; // sub set of dataItems

    placeholder = '';
    hintContent = '';
    isMatchJobTitle = true;
    isShowCreateContact = false;
    isShowCreateEntity = false;
    isShowCreateRelationship = false;
    isHide = true;
    isAutoClose = false;
    searchId = 'searchId';
    suggestionItems: Array<any> = []; // suggestion items based on search
    selectedItems: Array<any> = []; // selected items, sub set of dataItems
    selectedDictionary: any = {}; // selected items, using dictionary for quickly removing duplicates

    private _validRelationshipTypes: Array<ValidRelationshipType>;
    private _filterHandler$: Subject<string> = new Subject();
    private _searchValue: string;
    private _entityTypes: Array<EntityType>;
    private _source: any = {}; // mark data source configuration
    private _delimiter = ',';
    // watch another contraol's value, if it is not string, convert it to string, used for getting list according
    // a specific relationship of this vlue
    private _watchControlValue: any = [];
    private _destroySubscriptions: Array<Subscription> = [];

    private _relationshipType = '';
    private _fakeId = 'fakeId';
    constructor(
        private _entityService: EntityService,
        private _store: Store<AppState>,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _newRelationshipService: NewRelationshipService,
        private _toast: ToastService,
        private _contactTemplateService: ContactTemplateService,
    ) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        this._initData();
        this._changeValueSet(false);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
     *
     * @private
     * @memberof ContactMedComponent
     */
    private _initData() {
        this._destroySubscriptions.push(
            // feedback for fly entity result
            this._openDynamicComponentService.feedbackSubject$.subscribe((feedback: EntityBack) => {
                if (feedback.controlId === this.config.controlID) {
                    this._destroySubscriptions.push(
                        this._entityService.getEntityListByIdsQuick([feedback.entityId], this._source, this._watchControlValue)
                            .subscribe(res => this._setFlyValue(res)));
                }
            }),
            this._newRelationshipService.feedbackSubject$.subscribe((feedback: Relationship) => {
                if (this.config.controlID === ControlId.JobTitle) {
                    const flyRelationship = {
                        name: feedback.relationshipType,
                        id: feedback.relationshipId
                    };
                    this.suggestionItems.push(flyRelationship);
                    this.selectedItems.push(flyRelationship);
                }
            }),
            this._store.pipe(
                select(validRelationshipTypeSelector),
                filter(res => res && res.length > 0),
            ).subscribe(res => {
                this._validRelationshipTypes = res;
                this._initDataValue();
            }),
            this._filterHandler$.pipe(
                debounceTime(250),
            ).subscribe(filterStr => {
                if (filterStr && filterStr.length > 0) {
                    this._searching(filterStr);
                } else {
                    this._searching('');
                }
            }),
            this._store.pipe(
                select(contactNewAddedJobTitleSelector),
                filter(res => res && res.length > 0),
            ).subscribe(res => this._handleNewAddedJobTitle(res)),
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && this.selectedItems.length === 0 && this.config.isRequired) {
                    this.hintContent = businessConstants.tip;
                }
            }),
        );
    }

    /**
    * init edit value
    * @private
    * @memberof ContactInputComponent
    */
    private _initEditValue() {
        this.selectedDictionary = {};
        this.selectedItems = [];
        // init for relationship entities
        if (this.config.controlID === ControlId.JobTitle) {
            this.config.editValue.forEach(res => {
                if (!res.id && res.name) {
                    res.id = this._fakeId + UUID.UUID();
                    this._store.dispatch({
                        type: ADD_JOB_TITLE,
                        payload: res
                    });
                } else if (res.id && res.id.indexOf(this._fakeId) > -1) {
                    this._store.dispatch({
                        type: ADD_JOB_TITLE,
                        payload: {
                            name: res.name,
                            id: res.id,
                        }
                    });
                }
            });
            this.selectedItems = this.config.editValue;
            this.selectedItems.forEach(item => {
                this.selectedDictionary[item.id] = item.name;
            });
            this._changeValueSet(this.config.isSignature);
            this._searching('');
        }
        this._destroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(res => {
                if (res.type === JobTitleAction.ClearJobTitile && res.payload === this.config.controlID) {
                    this.clearValue();
                }
            }),
        );
    }

    handleFilter(value) {
        this._searchValue = value;
        this._filterHandler$.next(value);
    }

    /**
     * jobTitle value changed
     * @param {*} tappedItem
     * @returns
     * @memberof ContactMedComponent
     */
    valueChange(tappedItem) {
        this.hintContent = '';
        if (this.config.controlID === ControlId.JobTitle) {
            const searchIndex = tappedItem.findIndex(item => item.id === this.searchId);
            if (searchIndex > -1) {
                this._searchValue = tappedItem[searchIndex].name;
                delete tappedItem[searchIndex];
                tappedItem.splice(searchIndex, 1);
                const deleteIndex = this.suggestionItems.findIndex(item => item.id === this.searchId);
                this.suggestionItems.splice(deleteIndex, 1);
                this.createValidRelationshipByRestApi();
                this._contactTemplateService.changeValueStatus = true;
                return;
            }
            if (tappedItem.length >= 6) {
                this.isAutoClose = true;
            } else {
                this.isAutoClose = false;
            }
        }
        this._contactTemplateService.changeValueStatus = true;
        const originSelected = this.selectedDictionary;
        const originSelectedKeys = Object.keys(originSelected);
        this.selectedDictionary = {};
        tappedItem.forEach(ele => {
            this.selectedDictionary[ele.id] = ele.name;
        });
        // 1. For the remove:
        // 2. if user remove a job title, need to confirm if the job title is a fake job title
        if (originSelectedKeys.length > tappedItem.length) {
            const original = originSelectedKeys.find(origin => !tappedItem.find(target => target.id === origin) && origin.toString().indexOf(this._fakeId) > -1);
            if (original) {
                this._store.dispatch({
                    type: REMOVE_JOB_TITLE,
                    payload: {
                        name: originSelected[original],
                        id: original,
                    }
                });
            }
        }
        // 1. For the add:
        if (originSelectedKeys.length < tappedItem.length) {
            const targetIndex = tappedItem.findIndex(target => !originSelectedKeys.find(origin => target.id === origin) && target.id.toString().indexOf(this._fakeId) > -1);
            if (targetIndex > -1) {
                this._store.dispatch({
                    type: ADD_JOB_TITLE,
                    payload: {
                        name: tappedItem[targetIndex].name,
                        id: tappedItem[targetIndex].id,
                    }
                });
            }
        }
        this._changeValueSet(true);
        
        // Clear the filter text after selection to keep the dropdown clean
        setTimeout(() => {
            if (this.entitylist) {
                // Try to access the internal input element and clear it
                const inputElement = this.entitylist.wrapper?.nativeElement?.querySelector('.k-input-inner');
                if (inputElement) {
                    inputElement.value = '';
                }
                // Also trigger filterChange with empty string
                if (this.entitylist.filterChange) {
                    this.entitylist.filterChange.emit('');
                }
            }
        }, 0);
    }

    clearValue() {
        this.inputValue = '';
        this.selectedItems = [];
        this.selectedDictionary = []; // need to remove this array, or the store will keep the original value
        this.entitylist.clearFilter();
        this.entitylist.toggle(false);
        this._changeValueSet(true);
    }

    /**
  * Create Entity
  */
    createEntity() {
        this.showAddEntityDialog();
    }
    /**
     * Create Contact
     */
    createContact() {
        this.showAddContactDialog();
    }

    onOpen(event: any): void {
        if (this.selectedItems.length >= 7 && this.config.controlID === ControlId.JobTitle) {
            event.preventDefault();
        }
    }

    /**
     *  crate entity on the fly
     *
     * @memberof ContactMedComponent
     */
    showAddContactDialog() {
        const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
        _contactDialogOpenOptions.openType = ContactTemplateType.NewContact;
        const contact = new Contact();
        contact.name = this._searchValue;
        _contactDialogOpenOptions.contact = contact;
        const entityBack = new EntityBack();
        entityBack.controlId = this.config.controlID;
        entityBack.searchValue = this._searchValue;
        _contactDialogOpenOptions.entityBack = entityBack;
        _contactDialogOpenOptions.isFly = true;
        this._contactTemplateService.dialogOpen$.next(_contactDialogOpenOptions);
    }

    createValidRelationship() {
        const relationshipDialogOpenOptions = new RelationshipDialogOpenOptions();
        relationshipDialogOpenOptions.relationshiTyeName = this._searchValue;
        relationshipDialogOpenOptions.controlId = this.config.controlID;
        this._newRelationshipService.dialogOpen$.next(relationshipDialogOpenOptions);
    }

    createValidRelationshipByRestApi() {
        if (this.config.controlID === ControlId.JobTitle) {
            const invalidRelationshipTypeId = this._fakeId + new Date().getTime();
            const flyRelationship = {
                id: invalidRelationshipTypeId,
                name: this._searchValue
            };
            this.suggestionItems = this.dataItems;
            this.selectedItems.push(flyRelationship);
            this.selectedDictionary[flyRelationship.id] = flyRelationship.name;
            // below is for create the job title
            this._store.dispatch({
                type: ADD_JOB_TITLE,
                payload: flyRelationship
            });
            this.entitylist.clearFilter();
            this.entitylist.toggle(false);
            this._changeValueSet(true);
        }
    }

    showAddEntityDialog() {
        const _entityDialogOpenOptions = new EntityDialogOpenOptions();
        _entityDialogOpenOptions.openType = EntityDialogType.NewEntity;
        _entityDialogOpenOptions.instanceId = 'dynamic-1';
        _entityDialogOpenOptions.searchValue = this._searchValue;
        _entityDialogOpenOptions.controlId = this.config.controlID;
        // set entityTypeId for fly entity-Dialog
        if (this.config.source && this.config.source.entityType && this.config.source.entityType.length > 0) {
            // make the right entity type be from source.entityType
            _entityDialogOpenOptions.entityType = this.config.source.entityType;
            const hasType = this.config.source.entityType.some(item => {
                return this._entityTypes.findIndex(abc => abc.id === item) > -1;
            });
            if (hasType) {
                this._openDynamicComponentService.feedbackSubject$.pipe(
                    take(1),
                ).subscribe((feedback: EntityBack) => {
                    if (feedback.entityId) {
                        this._entityService.getEntityListByIdsQuick([feedback.entityId])
                            .subscribe(res => {
                                this._setFlyValue(res);
                            });
                    }
                });
                this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
            } else {
                this._toast.notify({
                    message: 'You do not have access to create entity of this type.',
                    style: NotificationStyles.Info
                });
            }
        } else {
            this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
        }
    }

    private _handleNewAddedJobTitle(newAddedJobTitle) {
        if (this.config.controlID === 'JobTitle' && newAddedJobTitle && newAddedJobTitle.length > 0) {
            const tempValidRelationshipTypes = Object.assign([], this._validRelationshipTypes);
            newAddedJobTitle.forEach(element => {
                if (element.count > 0) {
                    tempValidRelationshipTypes.push({
                        id: element.id,
                        childEntityType: EntityType.CONTACT,
                        parentEntityType: EntityType.CONTACT,
                        relationshipType: {
                            id: element.id,
                            name: element.name,
                        },
                        reciprocalRelationshipType: null,
                    });
                }
                this._filterRelationship(tempValidRelationshipTypes);
            });
        }
    }
    /**
     *
     * @private
     * @memberof ContactMedComponent
     */
    private _initDataValue() {
        if (this.config.controlID === ControlId.JobTitle) {
            this.placeholder = 'Create Job Title';
            this.isFly = true;
            this.isShowCreateRelationship = true;
            this._filterRelationship(this._validRelationshipTypes);
        }
        if (this.config.action === ContactTemplateType.EditContact  || this.config.isSignature) {
            this._initEditValue();
        }
    }

    private _filterRelationship(res) {
        this.suggestionItems = [];
        res.forEach(element => {
            if (element.childEntityType.id === EntityType.CONTACT.id &&
                element.parentEntityType.id === EntityType.CONTACT.id) {
                this.suggestionItems.push({
                    'id': element.relationshipType.id,
                    'name': element.relationshipType.name
                });
            }
        });
        if (this.suggestionItems.length !== 0) {
            this.suggestionItems = _lodash.sortBy(this.suggestionItems, item => item.name);
        }
        this.dataItems = this.suggestionItems;
    }

    private _searching(text) {
        if (this.config.controlID === ControlId.JobTitle) {
            this.suggestionItems = this.dataItems.filter((content) => content.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);

            const index = this.dataItems.findIndex((content) => content.name.toLowerCase() === text.toLowerCase());
            if (this.config.isAllowFly && index < 0 && text) {
                const searchItem = { 'name': text, 'id': this.searchId };
                this.suggestionItems.push(searchItem);
            }
        }
    }

    private _searchingDone(entityList): Array<EntityBrief> {
        return this._entityService.mapEntityBriefList(entityList);
    }

    private _setFlyValue(entityList) {
        if (entityList) {
            const item = this._entityService.mapEntityBriefList(entityList)[0];
            if (item) {
                this.selectedItems.push(item);
                this.suggestionItems.push(this.selectedItems);
                this._changeValueSet(true);
            }
        }
    }

    private _changeValueSet(isFromUser: boolean) {
        const valueSet = [];
        const nameSet = [];
        const actualValueSet = new Array<BriefObject>();
        // tslint:disable-next-line: forin
        for (const id in this.selectedDictionary) {
            valueSet.push(id);
            const val = this.selectedDictionary[id];
            nameSet.push(val);
            actualValueSet.push(new BriefObject(id, val));
        }
        const value = new ContactTemplateControlValue(valueSet.join(this._delimiter), nameSet.join(this._delimiter), this.config);
        if (this.config.controlID === ControlId.JobTitle && isFromUser) {
            // no matter edit or create, will have change job title function
            this._contactTemplateService.actionSubject$.next({
                type: JobTitleAction.ChangeJobTitle,
                payload: actualValueSet,
                prefixId: this.config.prefixId
            });
        }

        if (this.valueChangeSubject) {
            this.valueChangeSubject.next(value);
        }
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }

}
